import { createMap } from './mapbox';
import mapboxgl from 'mapbox-gl';

const singleMap = document.querySelector('.single-map');
const singleMapMarker = document.querySelector('.single-map-marker');

if (singleMap && singleMapMarker) {
    const lng = singleMapMarker.dataset.lng;
    const lat = singleMapMarker.dataset.lat;

    if (lng && lat) {
        const map = createMap({
            container: singleMap,
            center: [lng, lat],
            zoom: 14,
        });

        new mapboxgl.Marker(singleMapMarker).setLngLat([lng, lat]).addTo(map);

        map.scrollZoom.disable();
        map.addControl(new mapboxgl.NavigationControl({
            showCompass: false,
            showZoom: true
        }));
    }
}